import { Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";

interface SampleBadgeProps {
  className?: string;
  showIcon?: boolean;
}

export function SampleBadge({ className, showIcon = true }: SampleBadgeProps) {
  return (
    <span
      data-testid="badge-sample"
      title="This is sample/demo data — clear it from Settings."
      className={cn(
        "inline-flex items-center gap-1 rounded-md border border-dashed border-purple-400/40 bg-purple-500/10 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-purple-700 dark:text-purple-300 whitespace-nowrap",
        className,
      )}
    >
      {showIcon && <Sparkles className="h-3 w-3" />}
      Sample
    </span>
  );
}
